<template>
  <div class="account">
    <GlobalInfoBar title="付款商列表" />
    <GlobalChunk :padding="[20, 20, 20, 20]">
      <GlobalForm
        :init-data="initData"
        :form-rules="formRules"
        :form-item-list="formItemList"
        :inline="true"
        round
        @handleConfirm="query"
        confirmBtnName="查询"
        :label-width="120"
      >
        <div slot="AddSlot">
          <el-button type="success" size="mini" @click="exportExcel()"
            >打款商下载</el-button
          >
          <el-button type="warning" size="mini" @click="Refreshstatistics"
            >刷新统计</el-button
          >
          <el-button type="primary" size="mini" @click="addAccount"
            >新增账户</el-button
          >
        </div>
      </GlobalForm>

      <GlobalTable
        ref="GlobalTable"
        :columns="tableColumns"
        :data="tableData"
        :currentPage="curPage"
        :total="totalElements"
        @handleCurrentChange="currentChange"
        v-loading="loading"
      >
        <el-table-column label="类型" slot="repot" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.is_compony == 1 ? "对私" : "对公" }}</span>
          </template>
        </el-table-column>
         <el-table-column label="操作" slot="options" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="success" size="mini" @click="recordDwon(row)">记录日志下载</el-button>
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>
    <el-dialog
      title="新增账户"
      :visible.sync="addvisible"
      width="400px"
      :close-on-click-modal="false"
      @closed="closeAddAccount"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="账户名称" prop="group_pay_name">
          <el-input v-model="ruleForm.group_pay_name"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="is_compony">
          <el-select
            style="width: 100%;"
            v-model="ruleForm.is_compony"
            placeholder="请选择类型"
          >
            <el-option label="对公" :value="0"></el-option>
            <el-option label="对私" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submitForm('ruleForm')"
          >确认</el-button
        >
        <el-button size="small" @click="resetForm('ruleForm')">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/utils/request";
export default {
  name: "account",
  data() {
    return {
      loading:false,
      addvisible: false,
      initData: {},
      formRules: {},
      formItemList: [
        {
          key: "group_pay_name",
          labelWidth: "100px",
          type: "input",
          labelName: "打款账户名称:",
          placeholder: "请输入打款账户名称查询",
        },
        {
          key: "is_compony",
          type: "select",
          labelWidth: "50px",
          labelName: "类型",
          placeholder: "请选择类型",
          option: [
            { label: "全部", value: "" },
            { label: "对公", value: "0" },
            { label: "对私", value: "1" },
          ],
        },
      ],
      tableColumns: [
        { label: "打款账户名称", prop: "group_pay_name" },
        { label: "商家总额", prop: "total_money" },
        { label: "已用额度", prop: "spent_money" },
        { label: "剩余金额", prop: "remaind_money" },
         { slotName: "repot" },
         { slotName: "options" },
      ],
      tableData: [],
      curPage: 1,
      totalElements: 0,
      pageSize: 10,
      group_pay_name: "",
      is_compony: "",
      ruleForm: {
        group_pay_name: "",
        is_compony: "",
      },
      rules: {
        group_pay_name: [
          { required: true, message: "请输入账户名称", trigger: "blur" },
        ],
        is_compony: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    recordDwon(row) {
      api.downloadgroupPayLog({group_pay_id: row.id}).then((res) => {
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "服务异常");
            }
          } catch (err) {
            const fileName = "付款商记录日志.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
      });
    },
    exportExcel() {
      api.groupPayExport().then((res) => {
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "服务异常");
            }
          } catch (err) {
            const fileName = "付款商列表.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
      });
    },
    closeAddAccount() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm = {
        group_pay_name: "",
        is_compony: "",
      };
      this.addvisible = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          api.groupPayAddMerchant(this.ruleForm).then((res) => {
            this.$message.success("刷新成功!");
            this.addvisible = false;
            this.getList();
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.addvisible = false;
    },
    addAccount() {
      this.addvisible = true;
    },
    Refreshstatistics() {
      api.NewgroupPayUpdate().then((res) => {
        this.$message.success(res.msg);
        this.getList();
      });
    },
    query(data, cd) {
      cd();
      if (data) {
        this.group_pay_name = data.group_pay_name || "";
        this.is_compony = data.is_compony || "";
      }
      this.curPage = 1;
      this.getList();
    },
    currentChange(page) {
      this.curPage = page;
      this.getList();
    },
    getList() {
      this.loading = true;
      api
        .getgroupPayList({
          page: this.curPage,
          limit: this.pageSize,
          group_pay_name: this.group_pay_name,
          is_compony: this.is_compony,
        })
        .then((res) => {
          this.tableData = res.data;
          this.totalElements = res.count || 0;
        }).finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.account {
  //   /deep/ .el-form-item__label {
  //     width: 80px !important;
  //   }
}
</style>
